module.exports = __webpack_public_path__ + "img/0008.3d9b6da5.gif";